import React from "react";
import { TableCell } from "@mui/material";
import SyncAltIcon from "@mui/icons-material/SyncAlt";

// Columna "Almacén": nombre del almacén; si la solicitud está en Estado 1 y es
// "POINT WEB" y el usuario tiene permiso, muestra el ícono para cambiar bodega.
export default function CeldaAlmacen({ data, permisoCambiarBodega, handleOpenCambioBodega }) {
  return (
    <TableCell align="center">
      {data.Estado === 1 && data.almacen == "POINT WEB" && permisoCambiarBodega() ? (
        <div className="flex items-center justify-center">
          <span>
            <div className="relative inline-block">
              <SyncAltIcon
                onClick={() => handleOpenCambioBodega(data)}
                className="absolute -top-5 -right-3 text-blue-600 cursor-pointer hover:text-blue-800 transition-colors duration-200"
                fontSize="small"
              />

            </div>
          </span>
        </div>
      ) : null}
      {data.almacen}
    </TableCell>
  );
}
